"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHttpClient = createHttpClient;
var _createRequest = require("./createRequest.cjs");
var _types = require("./types.cjs");
function createHttpClient(options = {}) {
  const fetchImpl = options.fetch ?? fetch;
  return {
    get(url, {
      headers,
      query
    } = {}) {
      return (0, _createRequest.createRequest)(fetchImpl, url, {
        headers,
        method: _types.Method.GET,
        query
      });
    },
    post(url, {
      headers,
      payload,
      query
    } = {}) {
      return (0, _createRequest.createRequest)(fetchImpl, url, {
        headers,
        method: _types.Method.POST,
        payload,
        query
      });
    },
    put(url, {
      headers,
      payload,
      query
    } = {}) {
      return (0, _createRequest.createRequest)(fetchImpl, url, {
        headers,
        method: _types.Method.PUT,
        payload,
        query
      });
    },
    patch(url, {
      headers,
      payload,
      query
    } = {}) {
      return (0, _createRequest.createRequest)(fetchImpl, url, {
        headers,
        method: _types.Method.PATCH,
        payload,
        query
      });
    },
    delete(url, {
      headers,
      payload,
      query
    } = {}) {
      return (0, _createRequest.createRequest)(fetchImpl, url, {
        headers,
        method: _types.Method.DELETE,
        payload,
        query
      });
    }
  };
}